<div class="image-component-container">
  @if (helpText) {
    <div class="attribute-editor-component">
      <div class="text-sm attribute-editor-row">
        {{ helpText }}
      </div>
    </div>
  }
  <div
    class="image-component-list-duration"
    [shown]="selectedImages.length > 1 && !isUploading"
  >
    <label>Show each image for:</label>
    <div class="row">
      <div class="col-xs-12">
        <div class="input-group">
          <input
            type="number"
            class="form-control"
            [(ngModel)]="values.duration"
            (change)="saveDuration()"
          />
          <span class="input-group-addon">Seconds</span>
        </div>
      </div>
    </div>
    @if (false) {
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label
              id="te-image-transition-label"
              class="control-label u_margin-sm-top"
              for="te-image-transition"
              >Transition:</label
            >
            <mat-form-field
              appearance="outline"
              subscriptSizing="dynamic"
              class="tw-w-full"
            >
              <mat-select
                id="te-image-transition"
                [(ngModel)]="values.transition"
                aria-labelledby="te-image-transition-label"
                (selectionChange)="saveTransition()"
              >
                <mat-option value="">No Transition</mat-option>
                <mat-option value="fadeIn">Fade In</mat-option>
                <mat-option value="slideRight">Slide Right</mat-option>
                <mat-option value="slideLeft">Slide Left</mat-option>
                <mat-option value="slideUp">Slide Up</mat-option>
                <mat-option value="slideDown">Slide Down</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    }
  </div>

  <div
    class="image-component-list file-component-list te-scrollable-container"
    [ngClass]="{
      'active-duration': selectedImages.length > 1 && !isUploading,
      'active-help-text': helpText,
    }"
    rvSpinner="image-file-loader"
    [rvShowSpinner]="
      templateEditorService.loadingPresentation || stockLibraryService.loading
    "
  >
    <rv-sortable [sortableService]="sortableService">
      @for (image of selectedImages; track image) {
        <template-editor-file-entry
          rvSortableItem
          [shown]="selectedImages.length > 0 && !isUploading"
          [entry]="image"
          fileType="image"
          (removeEvent)="removeImageFromList($event)"
          [showGripHandle]="selectedImages.length > 1"
        />
      }
    </rv-sortable>
    <template-editor-empty-file-list
      fileType="image"
      [isEditingLogo]="isEditingLogo()"
      [hidden]="
        isUploading ||
        selectedImages.length !== 0 ||
        templateEditorService.loadingPresentation
      "
    >
    </template-editor-empty-file-list>
    <basic-uploader
      uploaderId="image-list-uploader"
      [uploadManager]="uploadManager"
      validType="image"
      [fileList]="fileUploadList"
      [shown]="isUploading"
    >
    </basic-uploader>

    @if (!isEditingLogo() && !isUploading && !isResponsive()) {
      <div class="layout-selector image-display-selector">
        <div class="attribute-editor-row">
          <div class="image-display-heading">
            <p id="image-display-label" class="image-display-title">
              Image display
            </p>
            <p class="image-display-description">
              Choose how the image fits within the frame.
            </p>
          </div>
          <div
            class="layout-container"
            role="radiogroup"
            aria-labelledby="image-display-label"
          >
            <button
              #sizingOptionBtn
              type="button"
              id="image-display-fill"
              class="layout-option image-display-option image-display-option--fill"
              [ngClass]="{
                'layout-option--selected': values.sizing === SIZING_FILL,
              }"
              (click)="setSizing(SIZING_FILL)"
              (keydown)="onSizingKeydown($event, SIZING_FILL)"
              [attr.aria-checked]="values.sizing === SIZING_FILL"
              [attr.tabindex]="values.sizing === SIZING_FILL ? 0 : -1"
              role="radio"
            >
              <div class="image-display-preview">
                <div class="image-display-frame">
                  <div class="image-display-photo"></div>
                  <div
                    class="image-display-handle image-display-handle--tl"
                  ></div>
                  <div
                    class="image-display-handle image-display-handle--tr"
                  ></div>
                  <div
                    class="image-display-handle image-display-handle--br"
                  ></div>
                  <div
                    class="image-display-handle image-display-handle--bl"
                  ></div>
                </div>
              </div>
              <div class="layout-label">Fill</div>
            </button>

            <button
              #sizingOptionBtn
              type="button"
              id="image-display-fit"
              class="layout-option image-display-option image-display-option--fit"
              [ngClass]="{
                'layout-option--selected': values.sizing === SIZING_FIT,
              }"
              (click)="setSizing(SIZING_FIT)"
              (keydown)="onSizingKeydown($event, SIZING_FIT)"
              [attr.aria-checked]="values.sizing === SIZING_FIT"
              [attr.tabindex]="values.sizing === SIZING_FIT ? 0 : -1"
              role="radio"
            >
              <div class="image-display-preview">
                <div class="image-display-frame">
                  <div class="image-display-photo-window">
                    <div
                      class="image-display-photo image-display-photo--fit"
                    ></div>
                  </div>
                  <div
                    class="image-display-handle image-display-handle--tl"
                  ></div>
                  <div
                    class="image-display-handle image-display-handle--tr"
                  ></div>
                  <div
                    class="image-display-handle image-display-handle--br"
                  ></div>
                  <div
                    class="image-display-handle image-display-handle--bl"
                  ></div>
                </div>
              </div>
              <div class="layout-label">Fit</div>
            </button>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="file-component-list-action-button-bar">
    <div class="pt-4 border-top">
      <button
        rv-button
        variant="secondary"
        tabindex="0"
        id="upload-images-unsubscribed"
        class="tw-w-full"
        (click)="currentPlanService.showUnlockThisFeatureModal()"
        [hidden]="currentPlanService.isPlanActive()"
      >
        <strong>{{ uploadButtonLabel }}</strong>
      </button>
      <button
        rv-button
        tabindex="0"
        id="image-list-uploader-label"
        class="tw-w-full aligner"
        (click)="activateImageUploader()"
        [disabled]="isUploading"
        [shown]="currentPlanService.isPlanActive()"
      >
        <strong>{{ uploadButtonLabel }}</strong>
      </button>
    </div>
    <div class="mt-3">
      <button
        rv-button
        variant="secondary"
        id="image-list-storage-button"
        class="tw-w-full"
        (click)="selectFromStorage()"
        [disabled]="isUploading"
      >
        <strong>Select from Storage</strong>
      </button>
    </div>
    <div class="mt-3">
      <button
        rv-button
        variant="secondary"
        id="stock-image-library"
        class="tw-w-full"
        (click)="stockLibraryService.showStockLibrary('image', boundAddFile)"
        [disabled]="
          isUploading || !featuresService.isFeatureAvailable('asset_library')
        "
      >
        <strong>Select from Stock Image Library</strong>
        @if (!featuresService.isFeatureAvailable('asset_library')) {
          <upgrade-notice feature="asset_library"></upgrade-notice>
        }
      </button>
    </div>
    @if (canGenerateWithAI()) {
      <div class="mt-3">
        <button
          rv-button
          variant="secondary"
          id="image-list-generate-ai"
          class="tw-w-full"
          [disabled]="isUploading"
          (click)="generateWithAI()"
        >
          <mat-icon svgIcon="ai-gradient" aria-hidden="true"></mat-icon>
          <strong>Generate with AI</strong>
        </button>
      </div>
    }
  </div>
</div>
